import React, { useMemo } from 'react';
import { useAITTheme, type AITTheme } from '@this/shared/ui/theme';

interface Props {
  initials?: string;
  size?: number;
}

const UserAvatar = ({ initials = 'U', size = 36 }: Props) => {
  const { theme } = useAITTheme();
  const styles = useMemo(() => getStyles(theme, size), [theme, size]);

  return (
    <div style={styles.avatar}>
      <span>{initials}</span>
    </div>
  );
};

const getStyles = (theme: AITTheme, size: number) => ({
  avatar: {
    width: `${size}px`,
    height: `${size}px`,
    borderRadius: '50%',
    backgroundColor: theme.grayBorderColor,
    color: theme.textColor,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontWeight: 600 as const,
    fontSize: '12px'
  }
});

export default UserAvatar;
